import { API_URL } from "../../../utils/config";

export const CREATE_ISSUE_URL = `${API_URL}/issues`;